// Photoshop-style text warp — original per-letter transform implementation.
// Each warp maps a normalized horizontal position tx in [-1, 1] and bend a in [-1, 1]
// to a per-letter transform: ty (translateY in em), sx/sy (scale), rot (deg), o (transform-origin).

const P = Math.PI;

export const WARPS = {
  none: () => ({ ty: 0, sx: 1, sy: 1, rot: 0, o: "center center" }),
  arc: (tx, a) => ({ ty: -0.5 * a * tx * tx, sx: 1, sy: 1, rot: 26 * a * tx, o: "center center" }),
  arcLower: (tx, a) => ({ ty: 0, sx: 1, sy: 1 + 0.6 * a * (1 - tx * tx), rot: 0, o: "center top" }),
  arcUpper: (tx, a) => ({ ty: 0, sx: 1, sy: 1 + 0.6 * a * (1 - tx * tx), rot: 0, o: "center bottom" }),
  arch: (tx, a) => ({ ty: -0.55 * a * (1 - tx * tx), sx: 1, sy: 1, rot: 0, o: "center center" }),
  bulge: (tx, a) => ({ ty: 0, sx: 1, sy: 1 + 0.7 * a * (1 - tx * tx), rot: 0, o: "center center" }),
  flag: (tx, a) => ({ ty: 0.5 * a * Math.sin(tx * P * 1.5), sx: 1, sy: 1, rot: 0, o: "center center" }),
  wave: (tx, a) => ({ ty: 0.45 * a * Math.sin(tx * P * 2), sx: 1, sy: 1, rot: 18 * a * Math.cos(tx * P * 2), o: "center center" }),
  fish: (tx, a) => ({ ty: 0, sx: 1 + 0.22 * a * tx, sy: 1 + 0.5 * a * (1 - Math.abs(tx)), rot: 0, o: "center center" }),
  rise: (tx, a) => ({ ty: -0.55 * a * tx, sx: 1, sy: 1, rot: 9 * a, o: "center center" }),
  fisheye: (tx, a) => ({ ty: 0, sx: 1 + 0.4 * a * (1 - tx * tx), sy: 1 + 0.6 * a * (1 - tx * tx), rot: 0, o: "center center" }),
  inflate: (tx, a) => ({ ty: -0.15 * a * (1 - tx * tx), sx: 1 + 0.16 * a * (1 - tx * tx), sy: 1 + 0.6 * a * (1 - tx * tx), rot: 0, o: "center bottom" }),
  squeeze: (tx, a) => ({ ty: 0, sx: 1, sy: 1 - 0.55 * a * (1 - tx * tx), rot: 0, o: "center center" }),
  shellUpper: (tx, a) => ({ ty: -0.4 * a * (1 - tx * tx), sx: 1, sy: 1 + 0.45 * a * (1 - tx * tx), rot: 0, o: "center bottom" }),
  shellLower: (tx, a) => ({ ty: 0.4 * a * (1 - tx * tx), sx: 1, sy: 1 + 0.45 * a * (1 - tx * tx), rot: 0, o: "center top" }),
  twist: (tx, a) => ({ ty: 0.2 * a * Math.sin(tx * P * 1.5), sx: 1, sy: 1 + 0.15 * a * Math.cos(tx * P), rot: 58 * a * tx, o: "center center" }),
};

export const WARP_LIST = [
  { id: "none", label: "None" },
  { id: "arc", label: "Arc" },
  { id: "arcLower", label: "Arc Lower" },
  { id: "arcUpper", label: "Arc Upper" },
  { id: "arch", label: "Arch" },
  { id: "bulge", label: "Bulge" },
  { id: "flag", label: "Flag" },
  { id: "wave", label: "Wave" },
  { id: "fish", label: "Fish" },
  { id: "rise", label: "Rise" },
  { id: "fisheye", label: "Fisheye" },
  { id: "inflate", label: "Inflate" },
  { id: "squeeze", label: "Squeeze" },
  { id: "shellUpper", label: "Shell Upper" },
  { id: "shellLower", label: "Shell Lower" },
  { id: "twist", label: "Twist" },
];
